import { Injectable } from '@angular/core';
import { ActivatedRoute, Router, UrlTree } from '@angular/router';
import { MareAuthService } from '@mare-common/ngx-mare-auth';
import { Observable } from 'rxjs';
import { TokenService } from '../token.service';
import { UserCompanyService } from '../userCompany.service';
import { AppGuard } from './app.guard';
import { environment } from 'src/environments/environment';
import { CommonConfig } from 'src/app/shared/common-config/common-config';

@Injectable({
  providedIn: 'root'
})
export class DoubleGuard {
  init: boolean = false;
  token: any;

  constructor(
    // private tokenService: TokenService,
    private appGuard: AppGuard,
    private userService: UserCompanyService,
    private router: Router,
    private route: ActivatedRoute,
    private commonConfigService: CommonConfig
  ) {

  }

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.init) {
      return this._canActivate();
    }
    return new Promise<boolean | UrlTree>((resolve, reject) => {
      if(window.location.search && window.location.search.startsWith('?')) {
        window.location.search.split('?')[1].split('&').forEach((param) => {
          const [key, value] = param.split('=');
          if(key == 'token') {
            this.token = value;
          }
        })
      };
      if (this.token) {
        resolve(this._canActivate());
      } else {
        // qui manca il token o non è valido e dobbiamo gestire il redirect alla landing in home Delfi
        resolve(this.appGuard.canActivate());
      }
      this.route.queryParams.subscribe(params => {
          
        });
    });
  }
  _canActivate(): boolean | UrlTree {

    // TODO verificare la bontà del token
    return true;

    // if(this.commonConfigService.getFromConfig('disallowAdminAccess', false) && this.userService.checkUserIsAdmin(this.user)) {
    //   return this.userService.redirectToAdmin();
    // }
    // if (!this.user?.name || !this.user?.surname || !this.user?.phone || !this.user?.phonePrefix) {
    //   return this.router.parseUrl('/account/completeProfile');
    // }

    // // console.log('can activate_______________________')
    // return true;
  }

}
